import { Button } from "@/components/ui/button";
import { FileSpreadsheet, FileDown } from "lucide-react";
import { exportUrl } from "@/lib/api";

export const ExportButtons = ({ collection, excelOnly }) => (
  <>
    <Button
      variant="outline"
      size="sm"
      data-testid={`export-${collection}-xlsx`}
      onClick={() => window.open(exportUrl(collection, "xlsx"), "_blank")}
      className="gap-2 border-border/60"
    >
      <FileSpreadsheet className="h-4 w-4 text-emerald-600" />
      Excel
    </Button>
    {!excelOnly && (
      <Button
        variant="outline"
        size="sm"
        data-testid={`export-${collection}-pdf`}
        onClick={() => window.open(exportUrl(collection, "pdf"), "_blank")}
        className="gap-2 border-border/60"
      >
        <FileDown className="h-4 w-4 text-red-600" />
        PDF
      </Button>
    )}
  </>
);
